import { useState, useEffect, useRef } from 'react';
import { Button } from '@quyva/shared-ui';
import { faPlay, faVolumeHigh } from '@fortawesome/free-solid-svg-icons';

export const TextReader = ({
    audioURLArray,
    id,
    activeId,
    enableSpeaker,
    setEnableSpeaker,
    enableReader,
    setActiveAudioId,
    setEnableScrollToBottom,
}) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const hasAudio = Array.isArray(audioURLArray) && audioURLArray.length > 0;

    useEffect(() => {
        if (id && hasAudio) {
            if (activeId === id && enableSpeaker && enableReader) {
                playChunk(0);
            } else {
                if (isPlaying) {
                    stopAudio();
                }
            }
        }
    }, [hasAudio, audioURLArray, activeId, enableSpeaker, enableReader, id]);

    const playChunk = async (index) => {
        if (!Array.isArray(audioURLArray) || audioURLArray.length === 0) {
            setIsPlaying(false);
            setActiveAudioId(null);
            setEnableSpeaker(false);
            return;
        }
        if (index >= audioURLArray.length) {
            setIsPlaying(false);
            setActiveAudioId(null);
            setEnableSpeaker(false);
            return;
        }

        // console.log('Playing chunk index:', index);
        if (audioRef.current) {
            audioRef.current.pause();
        }

        const newAudio = new Audio(audioURLArray[index]);
        audioRef.current = newAudio;

        newAudio.addEventListener('ended', () => {
            playChunk(index + 1);
        });

        try {
            await newAudio.play();
            if (!isPlaying) {
                setIsPlaying(true);
            }
        } catch (error) {
            console.warn('Audio play failed:', error);
            setIsPlaying(false);
        }
    };

    const stopAudio = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        setIsPlaying(false);
        setEnableSpeaker(false);
    };

    const togglePlayer = () => {
        if (isPlaying) {
            setActiveAudioId(null);
            stopAudio();
        } else {
            if (!hasAudio) {
                return;
            }
            setEnableScrollToBottom(false);
            setActiveAudioId(id);
            playChunk(0);
        }
    };

    useEffect(() => {
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current = null;
            }
        };
    }, []);

    return (
        <Button
            text={null}
            className={isPlaying ? 'animate-pulse ml-3' : 'ml-3'}
            hoverText={isPlaying ? 'Stop Reader' : 'Start Reader'}
            disabled={!enableReader && hasAudio}
            onClick={togglePlayer}
            icon={isPlaying ? faVolumeHigh : faPlay}
            type={'success'}
        />
    );
};
